const shortDate = {
	year: "numeric",
	month: "short",
	day: "numeric"
};
const longDate = {
	year: "numeric",
	month: "long",
	day: "numeric"
};
const shortDateTime = {
	...shortDate,
	hour: "numeric",
	minute: "numeric"
};
const numberFormat = {
	decimal: {
		style: "decimal",
		maximumFractionDigits: 0
	},
	percent: {
		style: "percent",
		maximumFractionDigits: 1
	},
	currency: {
		style: "currency",
		currency: "EUR",
		maximumFractionDigits: 0
	}
};
export default () => ({
	fallbackLocale: "en",
	datetimeFormats: {
		en: {
			short: shortDate,
			datetime: shortDateTime,
			long: {
				...longDate,
				weekday: "long",
				hour: "numeric",
				minute: "numeric"
			}
		},
		nl: {
			short: shortDate,
			datetime: shortDateTime,
			long: longDate
		},
		de: {
			short: shortDate,
			datetime: shortDateTime,
			long: longDate
		},
		fr: {
			short: shortDate,
			datetime: shortDateTime,
			long: longDate
		},
		es: {
			short: shortDate,
			datetime: shortDateTime,
			long: longDate
		},
		it: {
			short: shortDate,
			datetime: shortDateTime,
			long: longDate
		},
		pt: {
			short: shortDate,
			datetime: shortDateTime,
			long: longDate
		}
	},
	numberFormats: {
		en: numberFormat,
		nl: numberFormat,
		de: numberFormat,
		fr: numberFormat,
		es: numberFormat,
		it: numberFormat,
		pt: numberFormat
	}
});
